import { create } from 'zustand';

export type Quality = 'auto' | 'low' | 'medium' | 'high';

export interface Settings {
  masterVolume: number;
  musicVolume: number;
  sfxVolume: number;
  muted: boolean;
  quality: Quality;
  showFps: boolean;
  /** Camera zoom distance preference (metres). */
  cameraDistance: number;
  showDamageNumbers: boolean;
}

const KEY = 'jh.settings.v1';
const DEFAULTS: Settings = {
  masterVolume: 0.8,
  musicVolume: 0.45,
  sfxVolume: 0.8,
  muted: false,
  quality: 'auto',
  showFps: false,
  cameraDistance: 21,
  showDamageNumbers: true,
};

function load(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<Settings>) };
  } catch {
    return { ...DEFAULTS };
  }
}

interface SettingsState extends Settings {
  update(patch: Partial<Settings>): void;
}

export const useSettings = create<SettingsState>((set, get) => ({
  ...load(),
  update(patch) {
    set(patch);
    const { update: _u, ...rest } = get();
    try {
      localStorage.setItem(KEY, JSON.stringify(rest));
    } catch {
      /* storage unavailable (private mode) — settings still apply for this session */
    }
  },
}));
